module.exports = __webpack_public_path__ + "img/logoFoot.db9673bd.png";